<template>
    <div id="power-data" class="row-center" v-if="reFresh">
        <div class="p-title" v-if="uid=='Energy'">
            <span class="active">光伏报表</span>
        </div>
        <!-- <div class="p-title" v-else-if="uid=='Storage'">储能报表</div> -->
        <div class="p-title" v-else>
            <span :class="{active:uid === 'PowerTime'}" @click="checkreport('PowerTime')">用电量时段报表</span>
            <span :class="{active:uid === 'PowerRange'}" @click="checkreport('PowerRange')">尖峰平谷报表</span>
            <span :class="{active:uid === 'Running'}" @click="checkreport('Running')">电力运行报表</span>
            <span :class="{active:uid === 'Extremum'}" @click="checkreport('Extremum')">电力极值报表</span>
        </div>
        <div class="p-cont">
            <div class="left column-center">
                <div class="list">
                    <!-- <div class="active-title">{{reportName}}</div> -->
                    <div class="search">
                        <span>
                            <input type="text" v-model="filterText" placeholder="请输入关键字" />
                            <img src="../../assets/img/search.png" alt="" />
                        </span>
                        <el-checkbox v-model="checkstrictly" class="checkbox" v-if="uid!='PowerRange'&&uid!='Energy'">联级选择</el-checkbox>
                    </div>
                    <div class="tree" id="index-tree"  > 
                        <el-scrollbar style="height:100%">
                            <el-tree :expand-on-click-node="false" :check-strictly="!checkstrictly" check-on-click-node
                                default-expand-all @check="currentChange" :show-checkbox="showCheckBox" node-key="loopId" :props="defaultProps"
                                @node-click="nodeClick" ref="tree" :data="treeData" :filter-node-method="filterNode" :default-checked-keys="defaultchecked"
                                @check-change="handleCheckChange">
                                <span slot-scope="{ node, data }" class="power-data-item"
                                    :title="data.label.replace(/[^\x00-\xff]/g, 'AA').length>22?data.label:''">
                                    <span :class="[
                                            'power-data-item-label',
                                            { checked: data.loopId === currentLoop.loopId },
                                        ]">
                                        <span slot="reference"> {{ node.label }}</span>
                                    </span>
                                </span>
                            </el-tree>
                        </el-scrollbar>
                    </div>
                </div>
                <div class="clearsel" v-if="showCheckBox">
                    <span  @click="selALL()">全选</span>
                    <span  @click="resetChecked()" style="border-left:1px solid #ccc">清空选择</span>
                </div>
            </div>
            <div class="data">
                <div v-if="treeData.length === 0" class="no-found-data-warpper">
                    <img :src="require('../../assets/img/not_found_data.png')" alt="" />
                </div>
                <component v-else-if="currentLoop" :selectedLoops="checkedLoops" :currentLoop="currentLoop"
                    :is="componentName" />
            </div>
        </div>
    </div>
</template>
<script>
import reportDataBase from "./reportDataBase.vue";
    import {
        harmonicAnalysis,
        InverterArea
    } from "../../api/power";

    import {
        subscribe,
        unsubscribe,
        subscribeByNodes
    } from "../../mqtt/index";
    import {
        subscribe as alarmSubscribe,
        unsubscribe as alarmUnsubscribe,
    } from "../../mqtt/alarm";
    export default {
        name: "PowerDataHome",
        components: {
            reportDataBase
        },
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                checkstrictly:false,
                selectedNodes: [],
                reFresh: true,
                checkedLoops: [],
                currentLoop: null,
                filterText: "",
                loops: [],
                transformerList: [],
                defaultchecked:null,
                InverterList:[], //逆变器
                treeData:[]
            };
        },
        computed: {
            tag() {
                return this.$route.params.tag;
            },
            routeName() {
                return this.$route.params.name;
            },
            uid(){
               return  this.$route.query.uid
            },
            showCheckBox() {
                return !(
                    this.uid === "PowerRange" 
                );
            },
            componentName() {
                switch (this.$route.query.uid) {
                    case "PowerTime":
                    case "PowerRange":
                    case "Extremum":
                    case "Running":
                    case "Energy":
                    case "Storage":
                        return "reportDataBase";
                }
            },
            master() {
                let master = this.loops.filter((loop) => loop.loopType === "IN")[0];
                // if(master){
                //     this.defaultchecked = [master.loopId]
                //     this.$refs.tree.setCheckedNodes([master]);
                //     this.currentLoop = master;
                //     this.checkedLoops = [master]
                // }
                return master;
            },
            powerDataTree() {

                this.loops = this.loops.filter(
                    (l) => l.loopName.indexOf("电容补偿") === -1
                );
                let master = this.loops.filter((loop) => loop.loopType === "IN");
                if (!master) {
                    return this.loops.map((item, index) => {
                        item.label = item.loopName;
                        item.id = index;
                    });
                }
                // 存在进线
                let loopMap = {};
                // 将master的loopId作为key, 放入loopMap, value初始为[];
                master.forEach((item) => (loopMap[item.loopId] = []));
                // 遍历loops, 将所有OUT回路以pid(父级回路id)放入loopMap中的对应数组中
                this.loops.forEach((loop, index) => {
                    loop.label = loop.loopName;
                    loop.id = index;
                    if (loop.loopType === "OUT") {
                        if (this.uid == "Extremum" || this.uid == "Running") {
                            //报表管理不加电容补偿
                            if (loop.loopName.indexOf("电容补偿") == -1) {
                                if (loopMap[loop.pid]) {
                                    loopMap[loop.pid].push(loop);
                                }
                            }
                        } else {
                            if (loopMap[loop.pid]) {
                                loopMap[loop.pid].push(loop)
                            }
                        }

                    }
                });
                master.forEach((item) => {
                    item.children = loopMap[item.loopId];
                });

                
                return master;
            },
            // treeData() {
            //     switch (this.tag) {
            //         case "ReportForm":
            //             if(this.master){
            //                 debugger
            //                 if(this.checknum==0&&this.uid=='PowerTime'){
            //                     this.defaultchecked = [this.master.loopId]
            //                     this.$refs.tree.setCheckedNodes([this.master]);
            //                     this.currentLoop = this.master;
            //                     this.checkedLoops = [this.master]
            //                     this.selectedNodes = [this.master]
            //                 }else{
            //                     this.checkedLoops = []
            //                     this.defaultchecked = this.selectedNodes.map(e=>e.loopId)
            //                     this.$refs.tree.setCheckedNodes(this.selectedNodes);
            //                     this.checkedLoops = this.selectedNodes 
            //                 }
                            
            //             }
            //             return this.powerDataTree;
            //             break
            //         case "Storage":
            //             let obj = []
            //             for (let index = 1; index <= 224; index++) {
            //                 obj.push({label: "电池组"+index,loopName: "电池组"+index,loopId:index,id:index,status:"group"})
            //             }
            //             let battery = [{children: obj,label: "电池堆",loopId:0,id:0,loopName:"电池堆"}]
            //             this.defaultchecked = [0]
            //             this.currentLoop = battery[0]
            //             this.checkedLoops = battery.filter(e=> e.id==0)
            //             return battery
            //             break
            //         case "pvReportForm":
            //             if(this.InverterList.length>0){
            //                 let list = this.InverterList.filter(e=> e.label=e.loopName)
            //                 this.defaultchecked = [list[0].loopId];
            //                 this.checkedLoops = [list[0]]
            //                 this.currentLoop = list[0];
            //                 return list
            //             }else{
            //                 return []
            //             }
            //             break
            //     }
            // },
        },
        
        watch: {
            tag() {
                // this.reFresh = false;
                // this.$nextTick(() => {
                //     this.reFresh = true;
                // });
                // this.selectedNodes = [];
                // this.filterText = ""
                // this.checkedLoops = [];
                // this.$refs.tree.setCheckedNodes([]);
                this.getAlloop()
            },
            master(n, o) {
                
            },
            currentLoop(n, o) {
                
            },
            filterText(val) {
                this.$refs.tree.filter(val);
                this.checkedLoops = this.selectedNodes.filter((l) => {
                    return l.loopName.indexOf(val) !== -1;
                });
            },
            checkstrictly(n,o){

            },
        },
        mounted() {
            this.getAlloop();
        },
        methods: {
            handleCheckChange(data, checked, indeterminate) {
                // console.log(data, checked, indeterminate);
            },
            checkreport(name){
                this.$router.replace({ name: 'HomePageOverview', query: { uid: name } })
            },
            //全选
            selALL(){
                this.$nextTick(() => { 
                    let selectedNodes = []
                    this.treeData.forEach(item=>{
                        this.$refs.tree.setChecked(item.loopId,true)
                        selectedNodes.push(item)
                        item.children.forEach(elm=>{
                            this.$refs.tree.setChecked(elm.loopId,true)
                            selectedNodes.push(elm)
                        })
                        // this.$refs.tree.setChecked([item]);
                    })
                    this.selectedNodes = selectedNodes
                    this.checkedLoops = selectedNodes
                    // this.$refs.tree.setChecked(this.treeData);
                    // this.selectedNodes = this.treeData
                    // this.checkedLoops = this.treeData
                })
            },
            //所有回路
            async getAlloop(aid){
                let response = await harmonicAnalysis(
                    this.$store.state.project.currentProject.projectId
                );
                this.loops = response.data.data.deviceLoops || [];
                //逆变器
                this.InverterList = response.data.data.deviceLoops.filter(e=>e.loopType=='INVERTER') || [];
                console.log(this.powerDataTree,"this.powerDataTree")
                if(this.tag=='ReportForm'){  //电力报表
                    console.log(this.loops.filter(e=>e.loopType=='GTI'))
                    let gti = this.loops.filter(e=>e.loopType=='GTI')
                    if(this.$store.state.project.currentProject.projectId==13){
                        gti[0]['children'] = this.powerDataTree
                        this.treeData = gti
                        let self = this
                        setTimeout(function(){
                            self.defaultchecked = [gti[0].loopId]
                            self.$refs.tree.setCheckedNodes([gti[0]]);
                            self.currentLoop = gti;
                            self.checkedLoops = [gti[0]]
                            self.selectedNodes = [gti[0]]
                        },100)
                    }else{
                        this.treeData = this.powerDataTree

                        this.defaultchecked = [this.master.loopId]
                        this.$refs.tree.setCheckedNodes([this.master]);
                        this.currentLoop = this.master;
                        this.checkedLoops = [this.master]
                        this.selectedNodes = [this.master]
                    }

                }else{
                    if(this.InverterList.length>0){
                        let list = this.InverterList.filter(e=> e.label=e.loopName)
                        this.defaultchecked = [list[0].loopId];
                        this.checkedLoops = [list[0]]
                        this.currentLoop = list[0];
                        this.treeData = list
                    }
                }

            },
            resetChecked(){
                this.checkedLoops = []
                this.selectedNodes = []
                this.$refs.tree.setCheckedKeys([]);
            },
            unique(arr) {
                return Array.from(new Set(arr));
            },
            
            currentChange(data, node, n) {
                this.selectedNodes = node.checkedNodes;
                this.checkedLoops = this.selectedNodes.filter((l) => {
                    return l ? l.label.indexOf(this.filterText) !== -1 : false;
                });
            },
            //点击传参
            //侧边栏子回路点击之后传参
            nodeClick(data) {
                this.currentLoop = data;
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },

        },
    };
</script>

<style scoped lang="less">


    .clearsel{
        height:45rem;
        // line-height: 45rem;
        border-top: 1px solid rgba(0, 0, 0, 0.15);
        width: 100%;
        text-align: center;
        font-size: 18rem;
        cursor: pointer;
        padding: 10rem 0;
        span{
            display: inline-block;
            width: 50%;
        }
    }
    #power-data {
        width: 100%;
        height: 100%;
        // background: #ffffff;
        .p-title{
            font-size: 18rem;
            font-weight: bold;
            height: 50rem;
            line-height: 50rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            // padding: 0 20rem;
            width: 100%;
            background: #ffffff;
            span {
                display: inline-block;
                font-size: 16rem;
                font-weight: bold;
                border-top: 2px solid transparent;
                margin: 0 20rem;
                line-height: 50rem;
                cursor: pointer;
            }
            .active {
                border-top: 2px solid #0d94ff;
                color: #0d94ff;
            }
        }
        .p-cont{
            height: calc(100% - 50rem);
            width: 100%;
            justify-content: space-between;
            display: flex;
        }
        .data {
            position: relative;
            .w(860);
            height: 100%;
            background: #ffffff;
            flex: 1;
        }

        .left {
            height: 100%;
            justify-content: flex-start !important;
            background-color: #fff;
            .w(325);
            border-right: 1px solid rgba(0, 0, 0, 0.15);

            .list {
                padding: 20rem 0rem 24rem 24rem;
                overflow: hidden;
                width: 100%;
                .active-title{
                    font-size: 18rem;
                    font-weight: 500;
                    margin-bottom: 20rem;
                }
                .search {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: space-between;
                    align-items: center;
                    padding-right: 15px;
                }
                img{
                    vertical-align: -5px;
                }
                input {
                    border: none;
                    outline: none;
                    font-size: 18rem;
                    color: #666666;
                    .w(172);
                }
                .checkbox{
                    // margin-left: 20px;
                }

                .tree {
                    margin-top: 10rem;
                    height: 790 / 1080 * 100vh;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 0 !important;
                    }

                    /deep/ .el-scrollbar__wrap {
                        overflow-x: hidden;
                        height: calc(100% - 10px);
                    }

                    .el-tree {
                        padding-right: 24rem;
                    }
                }
            }
        }
    }

    .power-data-item {
        display: flex;
        justify-content: space-between;
        position: relative;
        width: 100%;

        .power-data-item1 {
            position: absolute;
            right: 0;
        }

        .power-data-item-label {
            font-size: 18rem;
            font-weight: 400;
            color: #666666;
            width: 80%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
        }

        .power-data-item-label.checked {
            font-weight: bold;
            color: #0d94ff;
        }

        .power-data-item-open {
            color: #68d86a;
            position: absolute;
            right: 0;
        }

        .power-data-item-close {
            position: absolute;
            right: 0;
            color: #fd4238;
        }
    }

    .no-found-data-warpper {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    }

    //弹出框样式
    .area_popper {
        background-color: #3d4451 !important;
        border-radius: 6px !important;
        opacity: 0.9 !important;
        font-size: 12px !important;
        color: #ffffff !important;
        padding: 0 !important;
        transform: translateY(12px);
    }

    .showText {
        margin: 8px;
    }

    &::-webkit-scrollbar {
        width: 0 !important;
    }

    /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
        height: calc(100% - 10px);
    }

    .el-tree {
        padding-right: 33rem;
    }
</style>